import { GenericCollectionFactory } from "../../_generics/GenericCollectionFactory";

export const PaymentMethodCollectionStore = GenericCollectionFactory("PAYMENT_METHODS", "uid");